import React, { useRef } from "react";

/** Leans a few degrees towards the pointer. Pure CSS vars, so no re-render on move. */
export default function Tilt({ children, className = "", max = 8, ...rest }) {
    const ref = useRef(null);
    const onMove = (e) => {
        const el = ref.current;
        const r = el.getBoundingClientRect();
        el.style.setProperty("--rx", `${((e.clientY - r.top) / r.height - 0.5) * -max}deg`);
        el.style.setProperty("--ry", `${((e.clientX - r.left) / r.width - 0.5) * max * 1.4}deg`);
    };
    const onLeave = () => {
        ref.current.style.setProperty("--rx", "0deg");
        ref.current.style.setProperty("--ry", "0deg");
    };
    return (
        <div ref={ref} className={`tilt ${className}`} onMouseMove={onMove} onMouseLeave={onLeave} {...rest}>
            {children}
        </div>
    );
}
